import * as d3 from 'd3';
import { DURATION } from '../utils';

export const VERTICAL = 'VERTICAL';
export const HORIZONTAL = 'HORIZONTAL';

export default function () {
  let handle = null;
  let height = 100;
  let extent = [0, 100];
  let orientation = VERTICAL;
  let animate = true;
  let visible = true;

  const dispatch = d3.dispatch('dragstarted', 'dragged', 'dragended');

  function draghandle(selection, isResize) {
    selection.each(function (data) {
      function dragstarted(d) {
        d3.select(this).raise().classed('active', true);
        dispatch.call('dragstarted', draghandle, orientation === VERTICAL ? d3.event.x : d3.event.y);
      }

      function dragged(d) {
        const pos = orientation === VERTICAL ? d3.event.x : d3.event.y;
        const posClampped = pos < extent[0] ? extent[0] : pos > extent[1] ? extent[1] : pos;

        handle.attr('transform', orientation === VERTICAL ? 'translate(' + posClampped + ',' + 0 + ')' : 'translate(0,' + posClampped + ')');

        dispatch.call('dragged', draghandle, posClampped);
      }

      function dragended(d) {
        d3.select(this).classed('active', false);
        const pos = orientation === VERTICAL ? d3.event.x : d3.event.y;
        const posClampped = pos < extent[0] ? extent[0] : pos > extent[1] ? extent[1] : pos;
        
        dispatch.call('dragended', draghandle, posClampped);
      }

      if (handle === null) {
        handle = selection.append('g')
          .attr('class', 'draghandle')
          .attr('transform', orientation === VERTICAL ? 'translate(' + data + ',' + 0 + ')' : 'translate(0,' + data + ')')
          .attr('cursor', orientation === VERTICAL ? 'ew-resize' : 'ns-resize')
          .call(d3.drag()
            .on('start', dragstarted)
            .on('drag', dragged)
            .on('end', dragended));

        handle.append('line')
          .attr(orientation === VERTICAL ? 'y1' : 'x1', 0)
          .attr('stroke', 'transparent')
          .attr('stroke-width', 6);

        handle.append('line')
          .attr(orientation === VERTICAL ? 'y1' : 'x1', 0)
          .attr('stroke', 'black')
          .attr('stroke-width', 1)
          .attr('opacity', 0.5);

        handle.append('path')
          .attr('d', 'M-5.5,-2.5v10l6,5.5l6,-5.5v-10z')
          .attr('fill', 'white')
          .attr('stroke', '#777');
      }

      handle.transition()
        .duration(animate ? DURATION : 0)
        .attr('transform', orientation === VERTICAL ? 'translate(' + data + ',' + 0 + ')' : 'translate(0,' + data + ')');

      handle.select('path')
        .attr('transform', orientation === VERTICAL ? 'translate(0,' + height + ')' : 'rotate(90,' + height + ',0)translate(' + height + ',0)');

      handle.selectAll('line')
        .attr(orientation === VERTICAL ? 'y2' : 'x2', height);

      handle.style('display', visible ? 'block' : 'none');
    });
  }

  draghandle.height = function (value) {
    if (!arguments.length) return height;
    height = value;
    return draghandle;
  }

  draghandle.extent = function (value) {
    if (!arguments.length) return extent;
    extent = value.sort();
    return draghandle;
  }

  draghandle.orientation = function (value) {
    if (!arguments.length) return orientation;
    orientation = value;
    return draghandle;
  }

  draghandle.animate = function (value) {
    if (!arguments.length) return animate;
    animate = value;
    return draghandle;
  }

  draghandle.visible = function (value) {
    if (!arguments.length) return visible;
    visible = value;
    return draghandle;
  }

  draghandle.on = function () {
    const value = dispatch.on.apply(dispatch, arguments);
    return value === dispatch ? draghandle : value;
  }

  return draghandle;
}


// WEBPACK FOOTER //
// ./src/charts/d3/d3-draghandle.js